export class WebhookV1StandardPayloadMpaRequestArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "mpaRequestNotification",
            "baseName": "mpaRequestNotification",
            "type": "WebhookV1MPARequestNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadMpaRequestArguments.attributeTypeMap;
    }
    constructor() {
    }
}
